export default __webpack_public_path__ + "static/media/discussion1image1.99dd16d4.png";